import classnames from 'classnames';
import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, GooglePhotoButton, Heading, Text } from '../../../../components/common';
import { GalleryIcon } from '../../../../components/common/SourceIcon/Icons/GalleryIcon';
import { useRootFolder } from '../../../../utils/hoc/withRootFolder';
import { useLoadingErrorCatcher } from '../../../../utils/hooks/useLoadingErrorCatcher';
import { isGooglePhotos as isGooglePhotosChecker } from '../../../../utils/media-manager-sdk/sources';
import { ExternalSourcesConfigs } from '../../constants/Sources';
import { ConnectSourceIcon } from '../ConnectSourceIcon/ConnectSourceIcon';
import styles from './NotConnected.scss';
import { IOuter } from './NotConnected.types';

export const NotConnected: FC<IOuter> = ({ className, onConnectClicked, source }) => {
  const { resetLoadingError } = useLoadingErrorCatcher();

  const rootFolder = useRootFolder(source);
  const handleConnectButtonClick = useCallback(() => {
    resetLoadingError();
    onConnectClicked(source);
  }, [resetLoadingError, onConnectClicked, source]);

  const isGooglePhotosSource = isGooglePhotosChecker(source);
  const { notConnectedMessage, IconComponent } = ExternalSourcesConfigs[source];

  return (
    <div className={classnames(styles.wrapper, className)}>
      <div className={styles.content}>
        <div className={styles.contentInner}>
          <ConnectSourceIcon>{isGooglePhotosSource ? <GalleryIcon /> : <IconComponent />}</ConnectSourceIcon>

          <Heading size="medium" className={styles.contentText}>
            {notConnectedMessage}
          </Heading>

          {isGooglePhotosSource ? (
            <GooglePhotoButton onClick={handleConnectButtonClick} />
          ) : (
            <Button size="small" onClick={handleConnectButtonClick} dataHook="connect-external-source-button">
              <FormattedMessage id="files-importer.connect-source.connect" values={{ sourceName: rootFolder.name }} />
            </Button>
          )}
        </div>
      </div>

      <Text weight="thin" size="small" tagName="div" className={styles.footer}>
        {isGooglePhotosSource ? (
          <FormattedMessage id="files-importer.connect-source.wont-be-affected.google-photos" />
        ) : (
          <FormattedMessage
            id="files-importer.connect-source.wont-be-affected"
            values={{ sourceName: rootFolder.name }}
          />
        )}
      </Text>
    </div>
  );
};
